<template>
  <div>
    <div>
      <loading
          :active.sync="loader"
          :can-cancel="false"
          :is-full-page="true"
      ></loading>
    </div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <!--CUANDO HAY BARRA LATERAL DE KITS -->
    <b-row v-if="listaTrtConArgumentario.length > 0">
      <b-col cols="4" v-if="!collapseTrt">
        <b-card style="border-radius: 30px;">
          <b-row>
            <b-col>
              <span class="w-100 ml-3 mb-3" style="color: #17A2B8 !important; font-size: 12px;">Tratamientos del kit con argumentario</span>
            </b-col>
            <b-col cols="2" class="m-0" align="right">
              <div v-b-tooltip.hover.topright.v-light title="Colapsar tratamientos" style="width: 14px; height: 16px">
                <font-awesome-icon :icon="['fas', 'arrow-left']" style="color: #17A2B8;" @click="activarColapse" />

              </div>
            </b-col>
          </b-row>
          <b-row v-for="(trt,indexTrt) in listaTrtConArgumentario" :key="indexTrt" @click="seleccionarTratamiento(trt,indexTrt)" style="cursor: pointer" :class="trt.seleccionado ? 'trtKitSeleccionado' : 'trtKitSinSeleccionar'">
            <b-col cols="1">
              <em v-if="trt.seleccionado" class="tratamiento_outline icon-boton"/>
              <em v-else class="tratamiento_outline_inactivo icon-boton"></em>
            </b-col>
            <b-col><span style="font-size: 11px; font-weight: 500">{{trt.nombreTratamiento}}</span></b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col v-if="!collapseTrt && datos.length > 0">
        <span class="w-100 ml-3 mb-3" style="color: #17A2B8 !important; font-size: 1em;">Tratamiento: {{trtSeleccionado.nombreTratamiento}}</span>
        <div class="row mb-2" style="flex-wrap: nowrap; overflow-x: scroll;">
          <div v-for="(archivo,indexArchivo) in datos" :key="indexArchivo" style="margin: 10px;">
            <div v-if="archivo.type.startsWith('image/')" class="frame-container" :class="{ activo: archivoSeleccionado === archivo }" @click="archivoSeleccionado = archivo">
              <img :src="archivo.url" alt="img" class="img-player" />
              <span style="font-size: 12px">img{{indexArchivo}}.{{archivo.extension}}</span>
            </div>
            <div class="frame-container" :class="{ activo: archivoSeleccionado === archivo }" v-else-if="archivo.type === 'video/mp4'" @click="archivoSeleccionado = archivo">
              <div class="videoPreview">
                <em class="playVideo_svg" style="width: 25px; height: 25px; position: absolute; top: 30%;left: 30%;"></em>
              </div>
              <span style="font-size: 12px">video{{indexArchivo}}.mp4</span>
            </div>
          </div>
        </div>
        <div>
          <div class="visor-file md">
            <template v-if="archivoSeleccionado">
              <img
                  v-if="archivoSeleccionado.type.startsWith('image/')"
                  :src="archivoSeleccionado.url"
                  class="img-fluid" :alt="archivoSeleccionado.nombreArchivo"
              />
              <video
                  v-else-if="archivoSeleccionado.type === 'video/mp4'"
                  :src="archivoSeleccionado.url"
                  controls
                  class="video-fluid"
                  style="max-width: 100%; max-height: 100%;"
              >
                <track kind="subtitles" src="#" srclang="es" label="Sin subtítulos" />
              </video>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- CUANDO SE COLAPSA LA BARRA LATERAL -->
    <b-row v-if="collapseTrt && datos.length > 0">
        <b-col cols="12" align="left" class="d-flex mb-3 align-items-center" style="gap: 10px">
          <b-button pill variant="outline-info" class="button-dent" @click="collapseTrt = false" v-b-tooltip.hover.topleft.v-light title="Mostrar tratamientos">
            <em class="tratamiento_outline icon-boton icon-dent-button"/>
          </b-button>
          <span class="w-100" style="color: #17A2B8 !important; font-size: 1em;">Tratamiento: {{trtSeleccionado.nombreTratamiento}}</span>
        </b-col>
          <b-col cols="2" style="cursor: pointer; overflow-y: scroll; gap: 10px; max-height: 330px;" class="d-flex flexColumn align-items-center">
            <div v-for="(archivo,indexArchivo) in datos" :key="indexArchivo" >
              <div v-if="archivo.type.startsWith('image/')" class="frame-container" :class="{ activo: archivoSeleccionado === archivo }" @click="archivoSeleccionado = archivo">
                <img :src="archivo.url" alt="img" class="img-player" />
                <span style="font-size: 12px">img{{indexArchivo}}.{{archivo.extension}}</span>
              </div>
              <div class="frame-container" :class="{ activo: archivoSeleccionado === archivo }" v-else-if="archivo.type === 'video/mp4'" @click="archivoSeleccionado = archivo">
                <div class="videoPreview">
                  <em class="playVideo_svg" style="width: 25px; height: 25px; position: absolute; top: 30%;left: 30%;"></em>
                </div>
                <span style="font-size: 12px">video{{indexArchivo}}.mp4</span>
              </div>
            </div>
          </b-col>
      <b-col class="d-flex justify-content-center align-items-center">
        <div class="visor-file">
          <template v-if="archivoSeleccionado">
            <img
                v-if="archivoSeleccionado.type.startsWith('image/')"
                :src="archivoSeleccionado.url"
                class="img-fluid"
                :alt="archivoSeleccionado.nombreArchivo"
            />
            <video
                v-else-if="archivoSeleccionado.type === 'video/mp4'"
                :src="archivoSeleccionado.url"
                controls
                class="video-fluid"
                style="max-width: 100%; max-height: 100%;"
            >
              <track kind="subtitles" src="#" srclang="es" label="Sin subtítulos" />
            </video>
          </template>
        </div>
      </b-col>
    </b-row>

    <!-- CUANDO SOLO EXISTE UN TRATAMIENTO -->
    <b-row v-if="listaTrtConArgumentario.length === 0 && datos.length > 0">
      <b-col cols="2" style="max-height: 383px;overflow-y: auto;">
        <div v-for="(archivo,indexArchivo) in datos" :key="indexArchivo" style="margin: 12px">
          <div v-if="archivo.type.startsWith('image/')" class="frame-container" :class="{ activo: archivoSeleccionado === archivo }" @click="archivoSeleccionado = archivo">
            <img :src="archivo.url" alt="img" class="img-player" />
            <span style="font-size: 12px">img{{indexArchivo}}.{{archivo.extension}}</span>
          </div>
          <div class="frame-container" :class="{ activo: archivoSeleccionado === archivo }" v-else-if="archivo.type === 'video/mp4'" @click="archivoSeleccionado = archivo">
            <div class="videoPreview">
              <em class="playVideo_svg" style="width: 25px; height: 25px; position: absolute; top: 30%;left: 30%;"></em>
            </div>
            <span style="font-size: 12px">video{{indexArchivo}}.mp4</span>
          </div>
        </div>
      </b-col>
      <b-col class="d-flex justify-content-center align-items-center">
        <div class="visor-file">
          <template v-if="archivoSeleccionado">
            <img
                v-if="archivoSeleccionado.type.startsWith('image/')"
                :src="archivoSeleccionado.url"
                class="img-fluid"
                :alt="archivoSeleccionado.nombreArchivo"
            />
            <video
                v-else-if="archivoSeleccionado.type === 'video/mp4'"
                :src="archivoSeleccionado.url"
                controls
                class="video-fluid"
                style="max-width: 100%; max-height: 100%;"
            >
              <track kind="subtitles" src="#" srclang="es" label="Sin subtítulos" />
            </video>
          </template>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {AwsService} from "@/apiServices/aws/AwsService";
import moment from "moment/moment";

export default {
  name: "ModalArgumentario",
  props: {
    idTratamiento: Number,
    nombreTratamiento: String,
    listaTrtConArgumentario: Array,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      isPlaying: false,
      showButton: false,
      loader: false,
      datos: [],
      token: null,
      awsServicio: new AwsService(),
      archivoSeleccionado: null,
      collapseTrt: false,
      trtSeleccionado: null,
    }
  },
  async created() {
    if(this.listaTrtConArgumentario.length > 0){
      this.trtSeleccionado = this.listaTrtConArgumentario[0]
      this.listaTrtConArgumentario[0].seleccionado = true;
    }
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWSGenerico();
    await this.validarTokenAWS();
    this.obtenerArgumentarioTx(this.idTratamiento);
  },
  methods: {
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAccesoGenerico().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWSGenerico(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAccesoGenerico().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWSGenerico(this.token)
        })
      }
    },

    obtenerArgumentarioTx(idTratamiento) {
      const params = {
        idTratamiento: idTratamiento
      }
      if (params.idTratamiento !== undefined){
        this.loader = true;
        this.$http.post(this.$api + 'argumentario/obtenerArgumentarioTx', params).then(response => {
          if (response.data.data) {
            const data = response.data.data
            if (data.listaArchivos && data.listaArchivos.length > 0) {
              const archivosDesdeServicio = data.listaArchivos.map(archivo => ({
                idArchivoArgumentario: archivo.idArchivoArgumentario,
                type: archivo.extension === 'mp4' ? 'video/mp4' : `image/${archivo.extension}`,
                url: `https://${this.token.nombreBucket}.s3.${this.token.regionBucket}.amazonaws.com/${decodeURIComponent(archivo.urlRuta)}`,
                nombreArchivo: archivo.nombreArchivo,
                extension: archivo.extension,
              }));
              this.datos = [...archivosDesdeServicio];
              this.archivoSeleccionado = archivosDesdeServicio[0];
            }else{
              this.datos = [];
              this.archivoSeleccionado = null;
            }

          }
        }).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message,
          })
        }).finally(() => {
          this.loader = false;
        })
      }
    },
    seleccionarTratamiento(item,index){
      this.listaTrtConArgumentario.forEach((lt,i)=>{
        lt.seleccionado = i === index;
      })
      this.trtSeleccionado = item;
      this.obtenerArgumentarioTx(item.idTratamiento)
    },
    activarColapse(){
      this.collapseTrt = true;
    }
  }
}
</script>

<style scoped>

.trtKitSeleccionado{
  border-width: 1px;
  border-style: solid;
  border-color: rgb(206, 235, 240);
  background: rgb(206, 235, 240);
  border-radius: 15px;
  color: #0e4b66;
}

.trtKitSinSeleccionar{
  color: grey !important;
}

.icon-boton {
  height: 25px;
  display: block;
  margin-top: 2px;
}

.frame-container{
  width: 90px;
  height: 85px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
}

.activo{
  background-color: #CAE9EE;
}

.img-player, .video-player {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  padding-top: 3px;
}

.frame-container span {
  color: #296B74;
  font-weight: 500;
  font-size: 9px;
  padding-bottom: 1px;
}

.video-player video{
  width: 70px; height: 70px; object-fit: cover; padding-top: 3px; border-radius: 5px;
}

.visor-file{
  width: 569px;
  height: 333px;
  border-radius: 5px;
}

.visor-file.md{
  width: 100%;
}

.visor-file .img-fluid{
  width: 100%;
  height: 333px;
  min-height: 100%;
  border-radius: 5px;
  object-fit: contain;
}

.visor-file .video-fluid{
  max-width: 100%;
  max-height: 100%;
  height: 333px;
  border-radius: 5px;
  object-fit: cover;
}

.icon-dent-button{
  position: absolute;
  top: 2px;
  right: 2px;
}

.button-dent{
  width: 35px;
  height: 35px;
  position: relative;
  border: 2px solid #62B6C2;
}

.button-dent:hover .icon-dent-button {
  filter: brightness(18.5);
}

.videoPreview {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  position: relative;
  align-content: center;
  border: 1px solid #62B6C2;
  margin-top: 3px;
}
</style>